
























































































































import Vue from 'vue'
import SystemsList from '@/components/SystemsList.vue'
import MapPage from '../pages/Index.vue'

import { titleize } from 'underscore.string'
import { mapState } from 'vuex';
import { firestore } from 'firebase';

export default Vue.extend({
  metaInfo() {
    return {
      title: this.resource
    }
  },
  name: "resource-page",
  components: { MapPage, SystemsList },
  props: {
    resource: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      fullscreen: false,
      items: [] as any[],
      hiddenItems: [] as any[],
      visibleItems: [] as any[],
      loading: true,
      menu: null as null | string,
      menus: {
        filter: {
          title: "Filter",
          fields: {}
        },
        search: {
          title: "Search",
          value: ""
        },
        sort: {
          title: "Sort",
          field: "name",
          direction: "asc"
        }
      },
      pageScrollTop: 0,
      query: {
        limit: 12,
        orderBy: {
          field: "name",
          order: undefined
        },
      },
      scrollingDown: false,
      unsubscribe: () => null as any
    }
  },

  computed: {
    
    filterFields():object[] {
        const fields = Object.entries(this.schema).filter(([key, field]) => field.options != undefined)
        if (this.resource == 'views') {
          fields.push([
            'upToDate',
            this.upToDateField()
          ])
        }
        return fields
    },
    sortFields():object[] {
      const fields = Object.entries(this.schema).filter(([key, field]) => field.sortable) || []
      if (this.resource == 'views') {
        fields.push([
          'upToDate',
          this.upToDateField()
        ])
      }
      return fields
    },
    schema(): { [key: string]: any }[] {
      return this["schemas"][this.resource]
    },
    ...mapState([
      "schemas"
    ]),
    viewsDisplay():string {
      return this.$store.state.viewsDisplay
    },
  },

  methods: {
    clearMenus() {
      this.$set(this.menus.filter, "fields", {})
      this.$set(this.menus.sort, "field", "name")
      this.$set(this.menus.sort, "direction", "asc")
      this.$set(this.menus.search, "value", "")
      history.pushState(
        {},
        document.title,
        this.$route.path + this.queryString()
      );
      this.updateResourceItems(this.resource)
    },
    focusSearch() {
      this.menu == 'search' ? this.menu = null : this.menu = 'search'
      const searchInput = document.getElementById('searchInput')
      const focusSearchInput = setInterval(() => {
        if (searchInput) {
          searchInput.focus()
          clearInterval(focusSearchInput)
        }
      }, 50)
    },
    pageScroll(event) {
      if (event.target.scrollTop > this.pageScrollTop) {
        this.scrollingDown = true
        this.$emit('scrollingDown', true)
      } else {
        this.scrollingDown = false
        this.$emit('scrollingDown', false)
      }
      this.pageScrollTop = event.target.scrollTop
    },
    queryString():string {
      const params = [] as string[]

      const filters = Object.entries(this.menus.filter.fields).filter(([key, value]) => typeof value !== 'undefined')
      if (filters.length) { params.push('filter=' + filters.map(([key, value]) => `${key}:${value}`).join(',')) }

      const search = this.menus.search.value
      if (search) { params.push(`search=${this.menus.search.value}`) }

      const sort = this.menus.sort.field
      if (sort) { params.push(`sort=${this.menus.sort.field},${this.menus.sort.direction || 'asc'}`) }
      return params.length ? '?' + params.join('&') : ''
    }, 
    searchInput(search:string) {
      history.pushState({}, document.title, this.$route.path + this.queryString())
      if ((search.length > 0)) {
        const words = search.toLowerCase().split(";");
        const items = this.items.filter(item => {
          return words.every(
            string =>
              JSON.stringify(Object.values(item))
                .toLowerCase()
                .indexOf(string.trim()) > -1
          )
        })
        this.visibleItems = this.sortAndFilter(items)
      } else {
        this.visibleItems = this.sortAndFilter(this.items)
      }
      this.menus.search.value = search
      this.loading = false
    },
    sortAndFilter(items: any[]) {
      const fields = Object.entries(this.menus.filter.fields)
      if (fields.length) {
        fields.forEach(field => {
          items = items.filter(item => {
            return (item[field[0]] == field[1]) || (field[1] == undefined)
          })
        })
      }
      const sortField = this.menus.sort.field
      if (sortField) {
        items.sort((a,b) => {
          let sort = 0
          //@ts-ignore
          const c = typeof a[sortField] == 'string' ? a[sortField].toLowerCase() : a[sortField]
          //@ts-ignore
          const d = typeof b[sortField] == 'string' ? b[sortField].toLowerCase() : b[sortField]

          if (c != undefined && d != undefined) {
            sort = c > d ? -1 : c < d ? 1 : 0
          } else if (c != undefined) {
            sort = -1
          } else if (d != undefined) {
            sort = 1
          }
          //@ts-ignore
          return this.menus.sort.direction == 'desc' ? sort : sort * -1
        })
      }
      return items
    },
    updateResourceItems(resource, query?) {

      this.unsubscribe()
      this.loading = true

      if (this.$store.state.auth.token.claims.super) {

          query = this.$db.collection(this.resource)

        } else if (this.$store.state.auth.token.claims.partner) {
          
          const partnerId = this.$store.state.auth.token.claims.partner
          
          query = this.$db.collection(this.resource)
            .where('partners', 'array-contains', partnerId)
          
        } else if (this.$store.state.auth.token.claims.client) {
          
          const clientId = this.$store.state.auth.token.claims.client
          query = this.$db.collection(this.resource)
            .where('clients', 'array-contains', clientId)

        } else {
          
          query = this.$db.collection(this.resource)
            .where('users', 'array-contains', this.$store.getters.user.id)

        }
      this.unsubscribe = query.onSnapshot((snapshot:firestore.QuerySnapshot) => {
        if(snapshot.docChanges().length) {
          snapshot.docChanges().forEach(change => {
            const item:{[key:string]:any} = {_id: change.doc.id, ...change.doc.data()}
            if (this.resource == 'views') {
              const date = Date.now() - item.captureInterval - 300000
              const imageDate = item.latestImageDate ? item.latestImageDate.seconds * 1000 : 0
              item.upToDate = date < imageDate
                  ? 1
                  : 0
            }
            const index = this.items.findIndex(_item => {
              return _item._id == item._id
            })
            if (index > -1) {
              this.$set(this.items, index, item)
            } else {
              this.$set(this.items, this.items.length, item)
            }
          })
        }
        if (this.loading == true) this.loading = false
        this.searchInput(this.menus.search.value)
      })
    },
    upToDateField() {
      return {
        label: "Up To Date?",
        options: [
          {
            value: 0,
            label: "Not Up To Date"
          },
          {
            value: 1,
            label: "Up To Date"
          }
        ],
        fieldTag: "select",
        fieldType: "option"
      }
    },
    async init() {
      this.items=[]
      this.loading = true
      const query = new URLSearchParams(decodeURI(window.location.search))
      if (query.get('filter')) {
        const filterString = query.get('filter') || ""
        window.console.log({filterString})
        const filters = filterString.split(',').forEach(filterPart => {
          const filter = filterPart.split(':')
          if (filter.length === 2) {
            this.menus.filter.fields[filter[0]] = filter[1]
          }
        })
      } else {
        this.menus.filter.fields = {}
      }

      this.menus.search.value = query.get('search') || ""
      
      if (query.get('sort')) {
        const sort = query.get('sort') || ""
        window.console.log({sort})
        this.menus.sort.field = sort.split(',')[0]
        this.menus.sort.direction = sort.split(',')[1] === 'asc' || sort.split(',')[1] === 'desc' ? sort.split(',')[1] : this.menus.sort.direction
      } else {
        this.menus.sort.field = ''
        this.menus.sort.direction = 'asc'
      }
      await this.updateResourceItems(this.resource)
    },
    popstateListener(event) {
      this.loading = true
      this.init()
    }
},

  watch: {
    resource() {
      this.init()
    }
  },

  filters: {

  },
  async created() {
    this.loading = true
    this.init()
    window.addEventListener('popstate', this.popstateListener)
  },
  mounted() {

  },
  updated() {

  },
  beforeDestroy() {
    this.unsubscribe()
    window.removeEventListener('popstate', this.popstateListener)
  }
})
